<template>
  <section class="p-0! bg-dustrose">
    <ResponsiveImage
      :media="content.image"
      class="aspect-square object-cover md:aspect-47/20 w-full"
      v-reveal="{ class: 'v-reveal-image' }"
    />
  </section>
</template>

<script lang="ts">
import type { PropType } from 'vue'

import ResponsiveImage from '@/components/helpers/ResponsiveImage.vue'

export default {
  name: 'ImageSection',
  components: { ResponsiveImage },
  props: {
    content: {
      type: Object as PropType<ImageSection>,
      required: true,
    },
  },
}
</script>
